import { Printer, UserRoundPen, Eraser, ChefHat, CircleSlash, ArrowRightLeft } from "lucide-react";

/**
 * Long-press options for an occupied table (short tap keeps its meaning: open
 * the order — which is why there is no "View / Edit Order" row here; a tap
 * already does that, unsent items and all). Renders only the actions that are
 * possible for THIS table — a disabled row explaining itself beats a hidden
 * one, but a row for an action the table can never take is noise, so callers
 * pass only what applies.
 */
export function TableOptionsSheet({ table, onMoveKot, onViewKots, onPrintBill, onEditCustomer, onCancelTable, onCheckKot, onReclaim, reclaimHint, onClose }) {
  const Row = ({ icon: Icon, label, hint, onClick, danger, testid }) => (
    <button
      className={`w-full flex items-center gap-3 px-4 py-4 text-left hover:bg-muted/40 transition-colors ${danger ? "text-destructive" : "text-foreground"}`}
      onClick={() => { onClick(); onClose(); }}
      data-testid={testid}
    >
      <Icon className="w-5 h-5 shrink-0" />
      <span className="flex-1 min-w-0">
        <span className="block text-body font-bold">{label}</span>
        {hint && <span className="block text-micro text-muted-foreground mt-0.5">{hint}</span>}
      </span>
    </button>
  );

  return (
    <div
      className="fixed inset-0 z-[90] flex items-end sm:items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-label={`Options for ${table?.name}`}
      data-testid="table-options-sheet"
    >
      <button className="absolute inset-0 bg-black/50" aria-label="Close" onClick={onClose} />
      <div className="relative w-full sm:max-w-sm bg-card rounded-t-2xl sm:rounded-2xl shadow-xl border overflow-hidden">
        <div className="px-4 py-3 border-b bg-muted/20">
          <strong className="text-body font-bold uppercase tracking-wide text-foreground">{table?.name}</strong>
        </div>
        <div className="divide-y">
          {onMoveKot && (
            <Row icon={ArrowRightLeft} label="Move Table / KOT" hint="Transfer table or specific items to another table" onClick={onMoveKot} testid="table-option-move-kot" />
          )}
          {onViewKots && (
                      <Row icon={ChefHat} label="View KOT" hint="Every KOT fired for this table, with times" onClick={onViewKots} testid="table-option-view-kots" />
                    )}
                    {onCheckKot && (
                      <Row icon={CircleSlash} label="Check KOT" hint="See the table's items on screen, then print the check" onClick={onCheckKot} testid="table-option-check-kot" />
                    )}
          {onPrintBill && (
            <Row icon={Printer} label="Print Bill" hint="Preview first — nothing prints yet" onClick={onPrintBill} testid="table-option-print-bill" />
          )}
          {onEditCustomer && (
            <Row icon={UserRoundPen} label="Edit Customer" onClick={onEditCustomer} testid="table-option-edit-customer" />
          )}
          {onCancelTable && (
            <Row
              icon={CircleSlash}
              label="Cancel Table"
              hint="Voids the whole order — PIN required"
              onClick={onCancelTable}
              danger
              testid="table-option-cancel-table"
            />
          )}
          {onReclaim && (
            <Row
              icon={Eraser}
              label="Clear stale claim"
              hint={reclaimHint}
              onClick={onReclaim}
              danger
              testid="table-option-reclaim"
            />
          )}
        </div>
        <button
          className="w-full h-12 text-body font-bold text-muted-foreground border-t hover:bg-muted/40"
          onClick={onClose}
          data-testid="table-option-cancel"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
